import { render } from "./index.vue?vue&type=template&id=0f2120ff"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabRefresh/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f2120ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f2120ff', __exports__)) {
    api.reload('0f2120ff', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0f2120ff", () => {
    api.rerender('0f2120ff', render)
  })

}


export default __exports__